/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

//020

document.getElementById("ouk").style.paddingBottom = "0px";

function showHideDiv(ele) {
				var srcElement = document.getElementById(ele);
				if (srcElement != null) {
					if (srcElement.style.display == "block") {
                        document.getElementById(ele).classList.remove("showdes")
                        document.getElementById(ele).classList.add("hidedes");
                        
						srcElement.style.display = 'none';
					}
					else {
                      document.getElementById(ele).classList.remove("hidedes")
                      document.getElementById(ele).classList.add("showdes");
						srcElement.style.display = 'block';
					}
					return false;
				}
}




(function() {
    let touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      let moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  
  
   setInterval(function(){
     $('[data-hulkdeleteproduct]').text('REMOVE')
     $('[data-addprotocart]').text('ADD TO CART')
    },60);
  
  
  $('body').on('click','[data-hulkgridview]',function(){
      var detachFunc = setInterval(function(){
      if($('.wishlist-status .wishlist-btn').length){
        console.log('found')
        $('[data-addprotocart]').text('ADD TO CART')
        $('[data-hulkdeleteproduct]').text('REMOVE')
        $('[data-wishlisttitle]').text('Wishlist');
        const wishlistText = $.trim($('.Product__Info').find('[data-wishlist]').text().toUpperCase())
        $.each($('[data-hulkgridviewcontainer]').find('.wishlist__product'), (i, html) => {
          const removeBtn = $(html).find('p.item__delete.grid__view').detach();  
          $(html).find(".wishlist-status .wishlist-btn").after(removeBtn);
        });   
        clearInterval(detachFunc);
      }

    }, 50);  
    
//     setInterval(function(){
//      $('[data-hulkdeleteproduct]').text('REMOVE')
//      $('[data-addprotocart]').text('ADD TO CART')
//     },60);
  
  })
   
  })();


window.onload = (event) => {
  $("[data-hulksubscribetolist]").text("OPT IN");
  $("[data-hulkloginmsg] .empty_content h3").text("Login to see your wishlist");
  $("[data-hulkloginmsg] .empty_content h3").addClass("text_font");
  $(".hulk__wishlist-wrap .wrapper .fancy_title [data-wishlisttitle]").hide();
  $(".wishlist-status .added_date.grid__view").hide()
  $("[data-hulkloginmsg]").css("margin" , "2rem");
  $("[data-formultipledisabled] [data-hulksubscribetolist]").css("font-size" ,"20px")
  $(".wishlist-modal__body .Subscribe-content [data-popuptitle]").text("Opt in to get alerts about your wishlist");
  $(".wishlist-modal__body .Subscribe-content [data-popupsubtitle]").text("We will notify you when items in your wishlist are restocked or go into sale")
   setInterval(function(){
    $(".wishlist-status .added_date.grid__view").hide();
       console.log('page is fully loaded');
    },1000);
  var htmlText = '';
   htmlText += $("<p>hello stackoverflow users</p>");
  console.log("htmlText",htmlText)
   $("[data-formultipledisabled]").prepend('<h3 id = "addtextalert">Get alerts when items from your wishlist go into sale</h3>').css("font-weight","Bold"); 
  
  
//   $('htmlText').append(".wrapper .fancy_title");
  $(".cfancy_title").append(htmlText);
//    $(".wishlist-status .added_date.list__view").hide()
};
